const state = () => ({
  model: "",
  modelid: 0,
  modelImg: "",
  engineID: 0,
  selectedEngine: 0,
  versionID: 0,

  basePrice: 0,
  rent: 0,
  taeg: 0,
  maxMounths: 0,
  incialEntry: 0,
  financing: 0,
  configSelected: {},

  wltp: 0,
  power: 0,
  powerKw: 0,

  pdfinBase64: null,
  hasFinances: false,
  creditType: "CREDIT",

  newCfg: true,
  isMotorSelected: true,
  isVersionSelected: true,
  // sessionID: 'an8dto4m0cia6h6b0ojblvt57q',
  // configurationID: '62a8985da73fb',
});

const getters = {
  getModelDetailsContent: (state) => {
    let str = "Até " + state.wltp + " km";
    let _power = state?.power;
    let powerType = " CV";
    if (_power == 0) {
      _power = state.powerKw;
      powerType = " Kw";
    }

    let strPower = _power + powerType;
    let wltp = { title: str, text: "Autonomia (WLTP)" };
    let power = { title: strPower, text: "Potência Máxima" };

    if (_power && state.wltp) return [wltp, power];
    if (_power) return [power];
    if (state.wltp) return [wltp];
  },
  getFullPrice: (state) => {
    return parseFloat(state.basePrice);
  },
  getDS_ClickToBuyParams: (state) => {
    const obj = {
      exteriorColorFactoryCode: state.configSelected?.dsgExt?.factoryCode,
      interiorColorFactoryCode: state.configSelected?.dsgInt?.factoryCode,
    };
    return obj;
  },
  getPdfConfig: (state, getters, rootState, rootGetters) => {
    const data = state;
    const engine = rootGetters["enginesData/getFullEngineByID"](
      data.selectedEngine
    );
    const version = rootGetters["versionsData/getVersionById"](data.versionID);

    const selectedCfg = data?.configSelected;
    const extColor = selectedCfg?.dsgExt;
    const intColor = selectedCfg?.dsgInt;
    const isCred = data.creditType == "CREDIT" ? true : false;

    const currStepObj = version || engine;

    const obj = {
      core: {
        modelName: data.model,
        basePrice: data.basePrice,
        rent: data.rent,
        versionName: currStepObj.designation,
        exteriorColorName: extColor?.designation || "",
        exteriorColorImage: data?.modelImg,
        isCred: isCred,
        isElectric: currStepObj.electricMotor != 0 ? true : false,
      },
      colors: {
        extDesignation: extColor?.designation,
        extFactoryCode: extColor?.factoryCode,
        extPrice: extColor?.price,
        intDesignation: intColor?.designation,
        intPrice: intColor?.price,
      },
      fnc: {
        initialValue: data?.incialEntry,
        rate: currStepObj?.rate,
        taeg: data?.taeg,
        capitalToFinance: data?.financing,
        initialExpenses: currStepObj?.initialExpenses,
      },
    };

    if (isCred == false) obj.fnc.residualValue = data.residualValue || 0;
    obj.fnc.nrPayments = data.maxMounths;

    return obj;
  },
};

const mutations = {
  UPDATE_STATE(state, payload) {
    state = Object.assign(state, payload);
  },
  UPDATE_CONFIGOPTIONS(state, payload) {
    state.configSelected = Object.assign({}, state.configSelected, payload);
    state.pdfinBase64 = null;
  },
  REMOVE_CONFIGOPTIONS(state, payload) {
    delete state.configSelected[payload];
  },
  UPDATE_CREDITTYPE(state, payload) {
    const creditType = payload ? "CREDIT" : "HOD";
    state.creditType = creditType;
  },
  CLEAR_STATE(state) {
    Object.keys(state).forEach((k) => {
      state[k] = null;
      if (k === "hasFinances") state[k] = false;
      if (k === "newCfg") state[k] = true;
      if (k === "creditType") state[k] = "CREDIT";
    });
  },
};

// const actions = {

// };

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  // actions,
};
